/*
 * Broadcast Theme - equipment-de-vie-duality David Beckett tekora.co.uk
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

;(function () {
  // Add custom code below this line
  document.addEventListener("DOMContentLoaded", function () {
    // Gsap Trigger Horizontal
    gsap.registerPlugin(ScrollTrigger)

    // Horizontal scroll
    const panels = gsap.utils.toArray(".panel")
    const totalPanels = panels.length

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".horizontal-scroll",
        start: "top top",
        end:
          "+=" +
          (document.querySelector(".horizontal-scroll").offsetWidth +
            window.innerHeight), // extend scroll distance
        scrub: 1,
        pin: true,
        anticipatePin: 1,
      },
    })

    // Horizontal scroll part
    tl.to(panels, {
      xPercent: -100 * (totalPanels - 1),
      ease: "none",
      duration: 1, // portion of the scroll timeline
    })

    // "Pause" at the end
    tl.to(
      {},
      {
        duration: 0.3, // adjust this to change pause length (0.3 = 30% of scroll duration)
        onUpdate: () => {}, // dummy update, nothing visually changes
      }
    )
  })

  // Video Horizontal Scroll
  document.querySelectorAll("video.panel-video").forEach((video) => {
    let src = ""

    if (window.matchMedia("(min-width: 1025px)").matches) {
      src = video.dataset.desktop
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      src = video.dataset.tablet
    } else {
      src = video.dataset.mobile
    }

    if (src) {
      const source = document.createElement("source")
      source.src = src
      source.type = "video/mp4"
      video.appendChild(source)
      video.load()
    }
  })

  // Active Section Scroll
  var activeSectionScroll = (function () {
    function sectionInView() {
      var sections = document.querySelectorAll(".shopify-section")
      var windowScrollTop = window.scrollY || window.pageYOffset
      var windowHeight = window.innerHeight

      sections.forEach(function (section) {
        var rect = section.getBoundingClientRect()
        var elementTop = rect.top + windowScrollTop
        var elementBottom = elementTop + section.offsetHeight

        var isInView =
          elementBottom > windowScrollTop &&
          elementTop < windowScrollTop + windowHeight * 0.62

        if (isInView) {
          section.classList.add("in-view")
        } else {
          section.classList.remove("in-view")
        }
      })
    }

    function init() {
      sectionInView()
      window.addEventListener("scroll", sectionInView)
      window.addEventListener("resize", sectionInView)
    }

    return {
      init: init,
    }
  })()

  // Initialize
  activeSectionScroll.init()

  // Animated Banner
  window.addEventListener("load", () => {
    gsap.registerPlugin(ScrollTrigger)

    const dial = document.querySelector(".dial-svg")

    if (dial) {
      let lastScroll = 0
      let isAnimating = false

      ScrollTrigger.create({
        trigger: ".animated-banner",
        start: "top bottom",
        end: "bottom top",
        onUpdate: (self) => {
          const currentScroll = self.scroll()

          if (!isAnimating && Math.abs(currentScroll - lastScroll) > 5) {
            isAnimating = true

            gsap.fromTo(
              dial,
              { rotate: "+=6" },
              {
                rotate: "-=30",
                duration: 0.6,
                repeat: 5,
                yoyo: true,
                ease: "sine.inOut",
                onComplete: () => {
                  isAnimating = false
                },
              }
            )

            lastScroll = currentScroll
          }
        },
      })
    }
  })

  let lottieInstance

  document.addEventListener("DOMContentLoaded", function () {
    const lottieContainer = document.getElementById("lottie-wave")

    if (lottieContainer) {
      const script = document.createElement("script")
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.10.1/lottie.min.js"

      script.onload = () => {
        lottieInstance = lottie.loadAnimation({
          container: lottieContainer,
          renderer: "svg",
          loop: false,
          autoplay: false,
          path: "https://cdn.shopify.com/s/files/1/0846/1398/8693/files/Animation_-_1748089712551.json?v=1748091198",
        })

        lottieInstance.setSpeed(0.6)
      }

      document.head.appendChild(script)
    }
  })

  const lottieObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            console.log("play shoe lottie once")

            lottieInstance?.play() // play only once
          }, 200)
          lottieObserver.unobserve(entry.target) // prevent replay
        }
      })
    },
    { threshold: 0.5 }
  )

  // Observe the section where the Lottie is
  const lottieTarget = document.querySelector(".shoe-mask") // or `.animated-banner-container`
  if (lottieTarget) {
    lottieObserver.observe(lottieTarget)
  }

  // observer.unobserve(entry.target);

  // Attach to parent of water-wave (e.g., .animated-banner or .shoe-mask)
  document
    .querySelectorAll(".animated-banner")
    .forEach((el) => lottieObserver.observe(el))

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})()
